(function() {
    'use strict';

    angular.module('swif.patrimoine')
    .config(route)
    .controller('PatrimoineKeysController', PatrimoineKeysController)
    .controller('PatrimoineKeysTabController', PatrimoineKeysTabController)
    .component('patrimoineKeysTable', {
        templateUrl: 'partials/patrimoine/patrimoine_keys_table.html',
        controller: PatrimoineKeysTabController,
        bindings: {
            'parentModel': '<'
        }
    });

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/patrimoine/keys/table_view', {
            templateUrl: 'partials/openbase/keys_table_view.html',
            controller: PatrimoineKeysController,
            controllerAs: '$ctrl',
            reloadOnSearch: false,
            resolve: {
                data: function(swifOpenbaseKeysService){
                    return swifOpenbaseKeysService.resolveData();
                }
            }
        });
    }

    // Controller used for the "keys / Badges" page
    function PatrimoineKeysController($scope, $location, data, swifFrameworkService, swifOpenbaseKeysService, swifOpenbaseKeyMovesService) {
        'ngInject';
        var $ctrl = this;
        var swif = swifFrameworkService;
        var service = swifOpenbaseKeysService;
        var moveService = swifOpenbaseKeyMovesService;

        $ctrl.keys = data;
        $ctrl.preModal = preModal;
        $ctrl.preValidate = service.preValidate;
        $ctrl.movePreValidate = moveService.preValidate;
        $ctrl.callback = service.callback;
        $ctrl.moveCallback = moveCallback;

        function preModal(data) {
            if (data.action.id === 'add') {
                data.model._type = 'site';
            } else if (data.action.id === 'edit') {
                data.model.equipment_id ? data.model._type = 'equipment' : data.model._type = 'site' ;
                data.model.site_ids = [];
                data.model.site_names.map((site) => {
                    data.model.site_ids.push(site[0]);
                });
                if (data.model.storage_equipment) {
                    data.model._storageType = 'equipment';
                }
            } else if (data.action.id === 'move_key') {
                var newModel = {};
                newModel.key_id = [data.model.id];
                newModel.date = moment(new Date()).utc().format('YYYY-MM-DD HH:mm');
                data.model.state === 'available' ? newModel.type = 'checkin' : newModel.type = 'checkout';
                if (data.model.state === 'entrusted') {
                    newModel.holder_contact = data.model.holder_contact;
                    newModel.people_name = data.model.people_name;
                    newModel.people_phone = data.model.people_phone;
                }
                // Clear old model to set move informations
                data.model = newModel;
            }
        }

        function moveCallback(error, data) {
            // Update key state
            service.getCollection().getItems();

            // Add new line to key moves
            return moveService.callback(error, data);
        }
    }

    // Controller used for the "keys / Badges" tab on a site or equipment detail page
    function PatrimoineKeysTabController($scope, $location, swifFrameworkService, swifOpenbaseKeysService, swifOpenbaseKeyMovesService) {
        'ngInject';
        var $ctrl = this;
        var swif = swifFrameworkService;
        var service = swifOpenbaseKeysService;
        var moveService = swifOpenbaseKeyMovesService;

        $ctrl.preModal = preModal;
        $ctrl.preValidate = service.preValidate;
        $ctrl.movePreValidate = moveService.preValidate;
        $ctrl.callback = service.callback;
        $ctrl.moveCallback = moveCallback;
        $ctrl.$onChanges = function (changes) {
            if (changes.parentModel) {
                getKeys();
            }
        };
        getKeys();

        function getKeys() {
            var filter = {};
            if ($ctrl.parentModel._type === "patrimoine_site" || $ctrl.parentModel_type === 'site') {
                swif.data.addExtraFilter(filter, 'site', 'site_ids', 'in', [$ctrl.parentModel.id])
            } else if ($ctrl.parentModel._type === "patrimoine_equipment") {
                swif.data.addExtraFilter(filter, 'equipment', 'equipment_id', '=', $ctrl.parentModel.id)
            }
            service.createCollection($ctrl.parentModel.id, filter).then(function(collection) {
                $ctrl.keys = collection;
            });
        }

        function preModal(data) {
            if (data.action.id === 'add') {
                data.model._type = $ctrl.parentModel._type === 'patrimoine_site' ? 'site' : 'equipment';
                data.model._isPatrimoine = true;
                if ($ctrl.parentModel._type === "patrimoine_site") {
                    data.model.site_ids = [$ctrl.parentModel.id];
                    data.model.storage_site = [
                        $ctrl.parentModel.id,
                        $ctrl.parentModel.name
                    ];
                } else if ($ctrl.parentModel._type === "patrimoine_equipment") {
                    data.model.equipment_id = [
                        $ctrl.parentModel.id,
                        $ctrl.parentModel.name
                    ];
                }
            } else if (data.action.id === 'edit') {
                data.model._type = $ctrl.parentModel._type === 'patrimoine_site' ? 'site' : 'equipment';
                data.model._isPatrimoine = true;
                data.model.site_ids = [];
                data.model.site_names.map((site) => {
                    data.model.site_ids.push(site[0]);
                });
                if (data.model.storage_equipment) {
                    data.model._storageType = 'equipment';
                }
            } else if (data.action.id === 'move_key') {
                var newModel = {};
                newModel.key_id = [data.model.id];
                newModel.date = moment(new Date()).utc().format('YYYY-MM-DD HH:mm');
                data.model.state === 'available' ? newModel.type = 'checkin' : newModel.type = 'checkout';
                if (data.model.state === 'entrusted') {
                    newModel.holder_contact = data.model.holder_contact;
                    newModel.people_name = data.model.people_name;
                    newModel.people_phone = data.model.people_phone;
                }
                // Clear old model to set move informations
                data.model = newModel;
            }
        }

        function moveCallback(error, data) {
            // Update key state
            service.getCollection().getItems();

            // Add new line to key moves
            return moveService.callback(error, data);
        }
    }
})();
